export function ToolbarSeparator() {
  return <span className="ql-format-separator" />;
}
ToolbarSeparator.displayName = 'RichTextEditor_ToolbarSeparator';
